(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["labelle-curated-cart-look"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('labelle-cart-look')) {
    customElements.define('labelle-cart-look', class extends HTMLElement {
      connectedCallback() {
        this.refresh = async () => {
          this.controller?.abort();
          this.controller = new AbortController();
          try {
            const url = new URL(this.dataset.cartUrl, location.origin);
            url.searchParams.set('section_id', this.dataset.sectionId);
            const response = await fetch(url, {signal: this.controller.signal});
            if (!response.ok) throw new Error('Cart recommendations unavailable');
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const next = html.querySelector('labelle-cart-look');
            this.innerHTML = next ? next.innerHTML : '';
          } catch (error) {
            if (error.name !== 'AbortError') this.innerHTML = '';
          }
        };
        document.addEventListener('cart:updated', this.refresh);
        document.addEventListener('cart:build', this.refresh);
      }
      disconnectedCallback() {
        this.controller?.abort();
        document.removeEventListener('cart:updated', this.refresh);
        document.removeEventListener('cart:build', this.refresh);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["labelle-curated-look"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('labelle-complete-look')) {
    customElements.define('labelle-complete-look', class extends HTMLElement {
      connectedCallback() {
        this.onVariant = (event) => {
          const variant = event.detail.variant;
          if (!variant || !this.dataset.variantIds.split(' ').includes(String(variant.id))) return;
          const index = this.dataset.colorIndex;
          this.hidden = index !== '' && variant.options[Number(index)] !== this.dataset.color;
        };
        document.addEventListener('variant:change', this.onVariant);
      }
      disconnectedCallback() { document.removeEventListener('variant:change', this.onVariant); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
